import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.function.name";
import { __decorate, __extends } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import noticePage from '../components/noticePage.vue';
import smMessagePage from '../components/smMessagePage.vue';

var AnnounceList = function (_super) {
  __extends(AnnounceList, _super);

  function AnnounceList() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.activeTab = 'noticePage';
    _this.tabList = [{
      value: 'noticePage',
      id: 'notice_list_noticePage',
      text: _this.t('公告通知')
    }, {
      value: 'smMessagePage',
      id: 'notice_list_smMessagePage',
      text: _this.t('站内信通知')
    }];
    return _this;
  }

  AnnounceList.prototype.onRouteChange = function (route) {
    if (route.name === 'AnnounceList') {
      var tab = this.$route.query.tab || 'noticePage';
      this.activeTab = tab;
    }
  };

  AnnounceList.prototype.handleTabChange = function (val) {
    this.$router.push({
      name: 'AnnounceList',
      query: {
        tab: val
      }
    });
  };

  AnnounceList.prototype.created = function () {
    var tab = this.$route.query.tab || 'noticePage';
    this.activeTab = tab;
  };

  __decorate([Watch('$route')], AnnounceList.prototype, "onRouteChange", null);

  AnnounceList = __decorate([Component({
    components: {
      noticePage: noticePage,
      smMessagePage: smMessagePage
    }
  })], AnnounceList);
  return AnnounceList;
}(Vue);

export default AnnounceList;